import React, { useState } from "react";
import { TrialRequestForm, PostTrialRequestForm } from "./form";
import { useMedia } from "use-media";

export const RequestForm = (props) => {
  const [contactId, setContactId] = useState("");
  const isTwoSections = useMedia({ maxWidth: "1200px" });
  const additionalClass = props.additionalClass;
  const additionalClassPaid = props.additionalClassPaid;
  const isSmall = useMedia({ maxWidth: "520px" });
  console.log("props.RequestForm", props, isSmall);
  console.log("contactid:::", contactId);
  return (
    <>
      {props.isFooterForm ? (
        <section
          className={`${"footer_form"} ${
            additionalClass ? additionalClass : ""
          }`}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12 footer_form_container d-flex flex-wrap justify-content-between align-items-start gap-4">
                <div className="footer_form_left footer-new-cta-update col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="main-slider-left footer-new-cta-update-section">
                    <h3 className="font-section-sub-header-bold font-section-cta-mobile-sub-header mb-32-responsive">
                      {props.product == "automate" ? (
                        <>
                          Auto-resolve 60% of Your Employee Queries With AI
                          Agents & Automation.
                        </>
                      ) : (
                        <>
                          Auto-resolve 60% of Your Employee Queries With AI
                          Agents & Automation.
                        </>
                      )}
                    </h3>
                  </div>
                </div>
                <div className="footer_form_right_cta col-lg-3 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-lg-center justify-content-center">
                  <div className="trial_header_left request_form_assist_left">
                    <div
                      className={`main-slider-button beta-button ${
                        !isTwoSections ? "pt-4" : "pt-0"
                      }`}
                    >
                      {console.log("one")}
                      <TrialRequestForm
                        // product="automate"
                        AutomateCTA={props.AutomateCTA}
                        fromPage={props.fromPage}
                        product={props.product}
                        automateContent={props.automateContent}
                        content={props.content}
                        autoamteButton={props.autoamteButton}
                        setContactId={setContactId}
                        list={props.list}
                        isFooterForm={props.isFooterForm}
                        parentContainerRef={props.parentContainerRef}
                        additionalClassForm={props.additionalClassForm}
                        contentHidden={props.contentHidden}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <div
          className={`main-slider-button beta-button home_page_button request_form_top_slider ${
            additionalClassPaid ? additionalClassPaid : ""
          }`}
        >
          <TrialRequestForm
            // product="automate"
            AutomateCTA={props.AutomateCTA}
            product={props.product}
            automateContent={props.automateContent}
            content={props.content}
            autoamteButton={props.autoamteButton}
            setContactId={setContactId}
            fromPage={props.fromPage}
            list={props.list}
            parentContainerRef={props.parentContainerRef}
            onRegisterSuccessCallback={
              props.needSecondForm ? null : props.onRegisterSuccessCallback
            }
            additionalClassForm={props.additionalClassForm}
            contentHidden={props.contentHidden}
          />
        </div>
      )}
      <PostTrialRequestForm
        contactId={contactId}
        fromPage={props.fromPage}
        setContactId={setContactId}
        list={props.list}
        product="automate"
        onRegisterSuccessCallback={
          props.needSecondForm ? props.onRegisterSuccessCallback : null
        }
      />
    </>
  );
};
